export default __webpack_public_path__ + "c4e8dff3d0a5f11e94781542fc156f4a.png";